module.exports = "\r\n.modal-backdrop.in {\r\n  opacity: 0.9;\r\n}\r\n\r\n.modal {\r\n  background-color: rgba(58, 51, 51, 0.4);\r\n  padding-top: 5px;\r\n}\r\n\r\n.confirm-message {\r\n  margin-bottom: 0px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.confirm-button {\r\n  text-align: center;\r\n  margin: 15px 0px 15px 0px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/confirm-dialog/confirm-dialog.component.css
// module id = ./src/app/shoppingcart/confirm-dialog/confirm-dialog.component.css
// module chunks = main